import { DecoratedCurrency } from './decorated-currency';

export interface CurrencyData {
    symbol: Currency;
    description: string;
    countryCode: string;
}
function ReadonlyMapWithStringKeys<K extends string, V>(
    iterable: Iterable<[K, V]>
): ReadonlyMap<K, V> {
    return new Map(iterable);
}
export type Currency = typeof CurrencyCountryCodes extends ReadonlyMap<infer K, any>
    ? K
    : never;

export const CurrencyCountryCodes = ReadonlyMapWithStringKeys([
    [
        'AUD',
        {
            symbol: 'AUD',
            description: 'Australian Dollar',
            countryCode: 'AU'
        }
    ],
    [
        'BRZ',
        {
            symbol: 'BRZ',
            description: 'Brazilian Real',
            countryCode: 'BR'
        }
    ],
    [
        'CAD',
        {
            symbol: 'CAD',
            description: 'Canadian Dollar',
            countryCode: 'CA'
        }
    ],
    [
        'CHF',
        {
            symbol: 'CHF',
            description: 'Swiss Franc',
            countryCode: 'CH'
        }
    ],
    [
        'CNY',
        {
            symbol: 'CNY',
            description: 'Yuan Renminbi',
            countryCode: 'CN'
        }
    ],
    [
        'DKK',
        {
            symbol: 'DKK',
            description: 'Danish Krone',
            countryCode: 'DK'
        }
    ],
    [
        'EUR',
        {
            symbol: 'EUR',
            description: 'Euro',
            countryCode: 'EU'
        }
    ],
    [
        'GBP',
        {
            symbol: 'GBP',
            description: 'Pound Sterling',
            countryCode: 'GB'
        }
    ],
    [
        'HUF',
        {
            symbol: 'HUF',
            description: 'Forint',
            countryCode: 'HU'
        }
    ],
    [
        'INR',
        {
            symbol: 'INR',
            description: 'Indian Rupee',
            countryCode: 'IN'
        }
    ],
    [
        'ILS',
        {
            symbol: 'ILS',
            description: 'New Israeli Sheqel',
            countryCode: 'IL'
        }
    ],
    [
        'ISK',
        {
            symbol: 'ISK',
            description: 'Iceland Krona',
            countryCode: 'IS'
        }
    ],
    [
        'JPY',
        {
            symbol: 'JPY',
            description: 'Yen',
            countryCode: 'JP'
        }
    ],
    [
        'NOK',
        {
            symbol: 'NOK',
            description: 'Norwegian Krone',
            countryCode: 'NO'
        }
    ],
    [
        'NZD',
        {
            symbol: 'NZD',
            description: 'New Zealand Dollar',
            countryCode: 'NZ'
        }
    ],
    [
        'PLN',
        {
            symbol: 'PLN',
            description: 'Zloty',
            countryCode: 'PL'
        }
    ],
    [
        'SEK',
        {
            symbol: 'SEK',
            description: 'Swedish Krona',
            countryCode: 'SE'
        }
    ],
    [
        'SGD',
        {
            symbol: 'SGD',
            description: 'Singapore Dollar',
            countryCode: 'SG'
        }
    ],
    [
        'THB',
        {
            symbol: 'THB',
            description: 'Baht',
            countryCode: 'TH'
        }
    ],
    [
        'USD',
        {
            symbol: 'USD',
            description: 'US Dollar',
            countryCode: 'US'
        }
    ],
    [
        'HKD',
        {
            symbol: 'HKD',
            description: 'Hong Kong Dollar',
            countryCode: 'HK'
        }
    ],
    [
        'VND',
        {
            symbol: 'VND',
            description: 'Vietnamese Dong',
            countryCode: 'VN'
        }
    ]
]);
